import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Switch, Redirect, Route } from "react-router-dom";
import Auth from "../../Layout/Auth";

const CRMDashboardPage = lazy(() => import('../Pages/CRMDashboardPage'))
const CRMPipelinePage = lazy(() => import('../Pages/CRMPipelinePage'))
const CRMScoringAdminPage = lazy(() => import('../Pages/CRMScoringAdminPage'))
const ProspectsPage = lazy(() => import('../Pages/ProspectsPage'))

class WalinerfunnelRoute extends Component {
    render() {
        const history = createHashHistory();
        return (
            <Switch>
                <Route
                    exact
                    path="/:lng/crm-dashboard"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <Suspense fallback={<Loading />}>
                                <CRMDashboardPage history={history} location={location} />
                            </Suspense>
                        </Auth>
                    )}
                />
                <Route
                    exact
                    path="/:lng/crm-pipeline"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <Suspense fallback={<Loading />}>
                                <CRMPipelinePage history={history} location={location} />
                            </Suspense>
                        </Auth>
                    )}
                />
                <Route
                    exact
                    path="/:lng/crm-scoring-admin"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <Suspense fallback={<Loading />}>
                                <CRMScoringAdminPage history={history} location={location} />
                            </Suspense>
                        </Auth>
                    )}
                />
                <Route
                    exact
                    path="/:lng/prospects"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <Suspense fallback={<Loading />}>
                                <ProspectsPage history={history} location={location} />
                            </Suspense>
                        </Auth>
                    )}
                />
            </Switch>
        );
    }
}
export default WalinerfunnelRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading...</span>
            </div>
        </>
    );
}
